import {HgIcon} from '~/design-system/hg/components'

type StarRatingProps = {
  rating: number
}

const Star = ({starType}: {starType: 'full' | 'half'}) => {
  return (
    <HgIcon
      iconType="star-solid"
      size="xs"
      className={
        starType === 'half'
          ? '[mask-image:linear-gradient(to_right,black_50%,transparent_50%)]'
          : ''
      }
    />
  )
}

export const StarRating = ({rating}: StarRatingProps) => {
  // Ensure rating is between 1 and 5
  const normalizedRating = Math.min(Math.max(1, rating), 5)

  // Get whole number of stars
  const fullStars = Math.floor(normalizedRating)

  // Check if we need a half star
  const hasHalfStar = normalizedRating - fullStars >= 0.5

  return (
    <div className="flex gap-s1">
      {[...Array(fullStars)].map((_, index) => (
        <Star key={`full-${index}-star`} starType="full" />
      ))}

      {hasHalfStar && <Star starType="half" />}
    </div>
  )
}
